import React from "react";
import { Layout, theme, Typography } from "antd";
import AddMeeting from "../components/meetings/AddMeeting";

const { Content } = Layout;

const MeetingAdd = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <Typography.Title level={5} className="titles-start">
            YENİ GÖRÜŞ
          </Typography.Title>
          <AddMeeting />
        </div>
      </Content>
    </Layout>
  );
};

export default MeetingAdd;
